import React, { useContext, useEffect, useState } from 'react';
import LiveTimer from '../../composed/LiveTimer/LiverTimer';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import { orderStatusMapping } from '../../utils/constants';
import AtomicButton from '../../atomic/button/Button';
import RunCircleIcon from '@mui/icons-material/RunCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CookingTimer from '../../composed/LiveTimer/CookingTimer';
import TextTransformation from '../../utils/textTransformation';
import { OrderDataProviderContext } from '../../context-api/data-provider/OrderDataProvider';
import Snackbar from '@mui/material/Snackbar';
import { Dialog } from '@mui/material';
import './dashboard.scss';
import './action-order-detail.scss';
import UpdateOrderTime from './UpdateOrderTime';
import CancelOrder from './CancelOrder';
import { getFriendlyDateLabel } from '../../utils/dateFormat';
import NoOrderFound from './NoOrderFound';
import { DisplayIcon } from '../../utils/DisplayIcons';
import PickupFreeItemNotice from './PickupFreeItemNotice';
import MealItemNamesSection from './MealItemNamesSection';

const ActionOrders = (props) => {
  const {
    newPendingOrder,
    setNewPendingOrder,
    preparingOrder,
    setPreparingOrder,
    scheduledOrder,
    setScheduledOrder,
    openOrderAlert,
    setOpenOrderAlert,
    allOrders,
    setAllOrders,
    openUpdateTimeDialog,
    setOpenUpdateTimeDialog,
    openCancelOrderDialog,
    setOpenCancelOrderDialog,
    openSnackBar,
    setOpenSnackBar,
    setInHouseDeliveryOrders,
  } = useContext(GlobalStateDataContext);

  const {
    onUpdateOrderStatus,
    updateOrderAPIResponse,
    setUpdateOrderAPIResponse,
    FetchOrders,
    clickedOrder,
    KitchenName,
    setClickedOrder,
  } = useContext(OrderDataProviderContext);

  const { loading } = updateOrderAPIResponse;
  const { vertical, horizontal, open } = openSnackBar;

  const [startNo, endNo] = (clickedOrder?.order_no || '').split('-');
  const isMealOrder = endNo?.includes('MEAL');
  const isJoinOrder = endNo?.includes('JOIN');
  const isPayAsYouGoOrder = endNo?.includes('PAY');
  const isPromoOrder = endNo?.includes('PROMO');

  // console.log('----PendingOrder', newPendingOrder)
  // console.log('----preparingOrder', preparingOrder)
  // console.log('--clickedOrder', clickedOrder)
  // const isJoinOrder = endNo?.includes('JOIN')
  // const isMealOrder = endNo?.includes('MEAL')
  // const isPayAsYouGoOrder = endNo?.includes('PAY')
  // const isPromoOrder = endNo?.includes('PROMO')

  const renderOrderItem = (item, index) => {
    let price = 'Meal item';
    let isMealItem = false;

    if (item?.price) {
      price = item.qty * item.price;
    }

    if (item?.product_category) {
      isMealItem = true;
    }

    const displayPrice = price === 'Meal item' ? 'Meal item' : `$${price}`;

    if (item?.promotion === 'buy_one_get_one_free' && price !== 'Meal item' && item.qty > 1) {
      price = (item.qty - Math.floor(item.qty / 2)) * item.price;
    } else if (
      item?.promotion === 'buy_two_get_one_free' &&
      price !== 'Meal item' &&
      item.qty > 2
    ) {
      price = (item.qty - Math.floor(item.qty / 3)) * item.price;
    } else if (
      item?.promotion === 'buy_one_get_half_price' &&
      price !== 'Meal item' &&
      item.qty > 1
    ) {
      price = (item.qty - Math.floor(item.qty / 2) + Math.floor(item.qty / 2) / 2) * item.price;
    }

    return (
      <div className='action-order-detail__item' key={`${item?.item}_${index}`}>
        <div className='action-order-detail__item-row'>
          <span className='action-order-detail__qty'>{item.qty}</span>
          <div className='action-order-detail__item-body'>
            <div className='action-order-detail__item-name'>{item.item}</div>
            {item?.promotion && (
              <div className='action-order-detail__item-promo'>
                Applied -{' '}
                <span className='action-order-detail__item-promo-label'>
                  {TextTransformation(item?.promotion)}
                </span>
              </div>
            )}
            {isMealItem && <div className='action-order-detail__item-tag'>Meal item</div>}
          </div>
          <div className='action-order-detail__item-price'>{displayPrice}</div>
        </div>
        {item?.extra_toppings?.length > 0 && (
          <div className='action-order-detail__topping-list'>
            {item.extra_toppings.map((t) => (
              <div className='action-order-detail__topping-row' key={t.topping_name}>
                <span className='action-order-detail__topping-name'>
                  {`${t.topping_name} (${t.topping_qty})`}
                </span>
                <span className='action-order-detail__topping-price'>
                  ${(t.topping_qty * t.price).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderMealOrderItem = (item, index) => {
    const price = 'Meal item';

    return (
      <div className='action-order-detail__item' key={`${item?.item}_${index}`}>
        <div className='action-order-detail__item-row'>
          <span className='action-order-detail__qty'>{item.qty}</span>
          <div className='action-order-detail__item-body'>
            <div className='action-order-detail__item-name'>{item.item}</div>
            {item?.promotion && (
              <div className='action-order-detail__item-promo'>
                Applied -{' '}
                <span className='action-order-detail__item-promo-label'>
                  {TextTransformation(item?.promotion)}
                </span>
              </div>
            )}
            {item?.product_category && (
              <div className='action-order-detail__item-tag'>Meal item</div>
            )}
          </div>
          <div className='action-order-detail__item-price'>{price}</div>
        </div>
        {item?.extra_toppings?.length > 0 && (
          <div className='action-order-detail__topping-list'>
            {item.extra_toppings.map((t) => (
              <div className='action-order-detail__topping-row' key={t.topping_name}>
                <span className='action-order-detail__topping-name'>
                  {`${t.topping_name} (${t.topping_qty})`}
                </span>
                <span className='action-order-detail__topping-price'>
                  ${(t.topping_qty * t.price).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const handleClose = (event, reason) => {
    setOpenSnackBar({
      ...openSnackBar,
      warning: false,
      open: false,
      snakBarMessage: '',
    });

    if (reason === 'clickaway') {
      return;
    }
  };

  const promoTypeLabel = (discount_type, discountedAmount) => {
    // You have to create paths on app.js before coming here to add tan name
    switch (discount_type) {
      case 'percentage':
        return `${discountedAmount}% off`;
      case 'plates':
        return `${discountedAmount} Free meal`;
      case 'amount_off':
        return `- $${discountedAmount} off`;
      case 'product':
        return `- $${discountedAmount} off`;
      case 'free_delivery':
        return `- $${discountedAmount} Delivery off`;
      case 'percentage_delivery':
        return `${discountedAmount}% Delivery off`;
      case 'free':
        return `Free order`;
    }
  };

  const HandleAcceptSubmit = async () => {
    const payload = {
      order_no: clickedOrder?.order_no,
      user_type: 'kitchen',
      operation: 'accept order',
    };

    setOpenSnackBar({
      ...openSnackBar,
      warning: false,
    });

    const checkResp = await onUpdateOrderStatus(payload);

    if (checkResp?.success && checkResp?.message === 'Order accepted!') {
      const indexToRemove = newPendingOrder.findIndex(
        (order) => order.order_no === clickedOrder?.order_no
      );

      if (indexToRemove !== -1) {
        setNewPendingOrder((prevOrders) => {
          const filteredOrders = prevOrders.filter(
            (order) => order.order_no !== clickedOrder?.order_no
          );
          return [...filteredOrders]; // Add only if not a duplicate
        });

        setPreparingOrder((prevOrders) => {
          const filteredOrders = prevOrders.filter(
            (order) => order.order_no !== clickedOrder?.order_no
          );
          return [
            ...filteredOrders,
            { ...clickedOrder, internal_order_status: 'order accepted by kitchen' },
          ]; // Add only if not a duplicate
        });
        setInHouseDeliveryOrders((prevOrders) => {
          const filteredOrders = prevOrders.filter(
            (order) => order.order_no !== clickedOrder?.order_no
          );

          return [
            ...filteredOrders,
            {
              ...clickedOrder,
              internal_order_status: 'order accepted by kitchen',
            },
          ];
        });
      }

      const key = `startTime_${clickedOrder?.order_no}`;
      const now = Date.now();
      localStorage.setItem(key, now.toString());

      setClickedOrder({});
      setOpenSnackBar({
        ...openSnackBar,
        open: true,
        warning: false,
        snakBarMessage: 'Successfully accepted',
      });
    }

    if (
      (checkResp?.success === false &&
        checkResp?.message === 'Operation is not allowed at this stage') ||
      checkResp?.message?.includes('Order with the order number')
    ) {
      setOpenSnackBar({
        ...openSnackBar,
        open: true,
        snakBarMessage: 'Action not permitted at this stage',
        warning: true,
      });
    }
  };

  if (newPendingOrder?.length <= 0) {
    return <NoOrderFound />;
  }

  return (
    <div className='action-orders-layout'>
      <div className='action-orders-list'>
        {newPendingOrder.map((item) => {
          const [startNo, endNo] = item.order_no.split('-');
          const totalItems = item?.item_names?.length;
          const mealTotalItems = item?.item_name?.length;

          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                // alignItems: 'center',
                height: 'auto',
                borderRadius: '3px',
                margin: '4px',
                padding: '10px',
                backgroundColor: 'rgb(24 20 54)',
                color: 'white',
                cursor: 'pointer',
              }}
              onClick={() => {
                setClickedOrder(item);
              }}
            >
              <div
                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
              >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <div
                    style={{
                      fontSize: '16px',
                      fontFamily: 'Inter Bold',
                      textTransform: 'capitalize',
                      letterSpacing: '0.5px',
                    }}
                  >
                    {' '}
                    {item.cust_firstName}
                  </div>
                  {DisplayIcon({ item: item, KitchenName: KitchenName, color: 'green' })}
                </div>

                <div
                  style={{
                    border: '2px solid #E78B48',
                    fontSize: '14px',
                    borderRadius: '3px',
                    padding: '2px 5px 2px 5px',
                    color: 'white',
                  }}
                >
                  {orderStatusMapping[item.internal_order_status]}
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginTop: '3px',
                }}
              >
                <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}> {`# ${endNo}`}</div>
                <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}>
                  {' '}
                  {totalItems || mealTotalItems}{' '}
                  {totalItems === 1 || mealTotalItems === 1 ? 'item' : 'items'}{' '}
                </div>
              </div>

              <div
                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
              >
                <div
                  style={{
                    margin: '20px 0px 5px 0px',
                    fontSize: '12px',
                    color: '#A8F1FF',
                  }}
                >
                  {`Accept the order within 5 minutes`}
                  {/* <LiveTimer /> */}
                </div>
                {item.delivery_type === 'home delivery' && (
                  <div
                    style={{
                      justifyContent: 'center',
                      display: 'flex',
                      color: 'rgb(24, 20, 54)',
                      border: '1px solid rgb(149, 237, 135)',
                      backgroundColor: 'rgb(149, 237, 135)',
                      padding: '5px',
                      borderRadius: '3px',
                      margin: '20px 0px 5px 0px',
                      width: '100px',
                      fontFamily: 'Inter Medium',
                      fontSize: '12px',
                      letterSpacing: '0.5px',
                    }}
                  >
                    {' '}
                    {item.delivered_by === 'kitchen' ? 'Store Delivery' : 'App delivery'}
                  </div>
                )}
                {item.delivery_type === 'pickup' && (
                  <div
                    style={{
                      color: 'rgb(24, 20, 54)',
                      border: '1px solid rgba(226, 243, 254, 1)',
                      backgroundColor: 'rgba(210, 235, 251, 1)',
                      justifyContent: 'center',
                      display: 'flex',
                      padding: '5px',
                      borderRadius: '3px',
                      margin: '20px 0px 5px 0px',
                      width: '80px',
                      fontFamily: 'Inter Medium',
                      fontSize: '12px',
                      letterSpacing: '0.5px',
                    }}
                  >
                    {' '}
                    {'Pickup'}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {Object.keys(clickedOrder).length > 0 && (
        <div className='action-order-detail-wrapper'>
          <div className='action-order-detail'>
            <div className='action-order-detail__inner'>
              <header className='action-order-detail__header'>
                <div className='action-order-detail__header-top'>
                  <div className='action-order-detail__customer-block'>
                    <h2 className='action-order-detail__customer-name'>
                      {clickedOrder?.cust_firstName}
                    </h2>
                    <p className='action-order-detail__order-no'>{endNo}</p>
                  </div>

                  <div className='action-order-detail__delivery-block'>
                    {clickedOrder?.delivery_type === 'home delivery' && (
                      <span className='action-order-detail__delivery-type'>
                        <LocalShippingIcon sx={{ color: '#181436', fontSize: 20 }} />
                        Home Delivery
                      </span>
                    )}
                    {clickedOrder?.delivery_type === 'pickup' && (
                      <span className='action-order-detail__delivery-type'>
                        <RunCircleIcon sx={{ color: '#181436', fontSize: 20 }} />
                        Pickup
                      </span>
                    )}
                    {clickedOrder?.delivered_by === 'kitchen' && (
                      <span className='action-order-detail__badge action-order-detail__badge--restaurant'>
                        Restaurant Delivery
                      </span>
                    )}
                  </div>
                </div>

                <div className='action-order-detail__meta-grid'>
                  <div className='action-order-detail__meta-card'>
                    <span className='action-order-detail__meta-label'>Delivery slot</span>
                    <span className='action-order-detail__meta-value'>
                      {clickedOrder?.delivery_time_slot}
                    </span>
                  </div>
                  <div className='action-order-detail__meta-card'>
                    <span className='action-order-detail__meta-label'>Date</span>
                    <span className='action-order-detail__meta-value action-order-detail__meta-value--date'>
                      {getFriendlyDateLabel(clickedOrder?.delivery_date)}
                    </span>
                  </div>
                </div>
              </header>

              {isMealOrder === false && Object.keys(clickedOrder).length > 0 && (
                <section className='action-order-detail__section'>
                  <h3 className='action-order-detail__section-title'>
                    Item{clickedOrder?.item_names?.length > 1 ? 's' : ''}
                  </h3>
                  <div className='action-order-detail__items-list'>
                    {clickedOrder?.item_names?.map(renderOrderItem)}
                  </div>
                </section>
              )}

              {isMealOrder === true && Object.keys(clickedOrder).length > 0 && (
                <section className='action-order-detail__section'>
                  <h3 className='action-order-detail__section-title'>
                    Item{clickedOrder?.item_name?.length > 1 ? 's' : ''}
                  </h3>
                  <div className='action-order-detail__items-list'>
                    {clickedOrder?.item_name?.map(renderMealOrderItem)}
                  </div>
                </section>
              )}

              <MealItemNamesSection order={clickedOrder} />

              <PickupFreeItemNotice order={clickedOrder} />

              <div className='action-order-detail__summary'>
                <div className='action-order-detail__summary-row'>
                  <span>Sub total</span>
                  <span className='action-order-detail__summary-value'>
                    ${(clickedOrder?.sub_total || 0.0)?.toFixed(2)}
                  </span>
                </div>
                <div className='action-order-detail__summary-row'>
                  <span>Delivery Fee</span>
                  <span className='action-order-detail__summary-value'>
                    $
                    {clickedOrder?.delivery_price?.toFixed(2) ||
                      clickedOrder?.deliverySubscription_fee?.toFixed(2)}
                  </span>
                </div>

                {clickedOrder?.discount_coupon_no && (
                  <>
                    <div className='action-order-detail__summary-row action-order-detail__summary-row--discount'>
                      <span>Discount</span>
                      <span className='action-order-detail__summary-value'>
                        {promoTypeLabel(
                          clickedOrder?.discount_type,
                          clickedOrder?.discountedAmount
                        )}
                      </span>
                    </div>
                    <div className='action-order-detail__summary-row'>
                      <span>Discount code</span>
                      <span
                        className='action-order-detail__summary-value'
                        style={{ textTransform: 'uppercase' }}
                      >
                        {clickedOrder?.discount_coupon_no}
                      </span>
                    </div>
                  </>
                )}

                <div className='action-order-detail__summary-row'>
                  <span>Tax & other fee</span>
                  <span className='action-order-detail__summary-value'>
                    ${(clickedOrder?.tax_plus_serviceFees || clickedOrder?.tax)?.toFixed(2)}
                  </span>
                </div>
                <div className='action-order-detail__summary-row'>
                  <span>Tip</span>
                  <span className='action-order-detail__summary-value'>
                    ${clickedOrder?.tip?.toFixed(2)}
                  </span>
                </div>

                {clickedOrder?.promoOrderAmountAdded_In_Total_charged !== 0 && (
                  <div className='action-order-detail__summary-row action-order-detail__summary-row--promo'>
                    <div className='action-order-detail__summary-label-group'>
                      <span>Complimentary Item</span>
                      <span className='action-order-detail__summary-sub'>
                        Packaging & Delivery Fee
                      </span>
                      <span className='action-order-detail__summary-sub action-order-detail__summary-sub--green'>
                        Arriving Tomorrow
                      </span>
                    </div>
                    <span className='action-order-detail__summary-value'>
                      ${clickedOrder?.promoOrderAmountAdded_In_Total_charged?.toFixed(2)}
                    </span>
                  </div>
                )}

                <div className='action-order-detail__summary-total'>
                  <span>Total</span>
                  <span>${clickedOrder?.total_charged?.toFixed(2)}</span>
                </div>
              </div>

              <div className='action-order-detail__actions'>
                <div className='action-order-detail__actions-primary'>
                  <AtomicButton
                    label='Accept'
                    handleSubmit={HandleAcceptSubmit}
                    style={{
                      backgroundColor: '#81E7AF',
                      color: '#1E3E62',
                    }}
                    loading={false}
                    disabled={false}
                  />
                </div>

                <div className='action-order-detail__actions-secondary'>
                  <div>
                    <AtomicButton
                      label='Cancel Order'
                      handleSubmit={() => {
                        setOpenCancelOrderDialog(true);
                      }}
                      style={{
                        backgroundColor: '#fff4e7',
                        width: '100%',
                        margin: '0px',
                        color: 'gray',
                      }}
                      loading={loading}
                      disabled={loading}
                    />
                  </div>
                  <div>
                    <AtomicButton
                      label='Update Time'
                      handleSubmit={() => {
                        setOpenUpdateTimeDialog(true);
                      }}
                      style={{
                        backgroundColor: '#e8e8e8',
                        color: 'rgb(24, 20, 54)',
                        width: '100%',
                        margin: '0px',
                      }}
                      loading={false}
                      disabled={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        className={openSnackBar?.warning ? 'warning-order-snackbar' : 'order-snackbar'}
        autoHideDuration={5000}
        onClose={handleClose}
        message={openSnackBar?.snakBarMessage}
      />

      {openUpdateTimeDialog && <UpdateOrderTime HandleAcceptSubmit={HandleAcceptSubmit} />}

      {openCancelOrderDialog && <CancelOrder />}
    </div>
  );
};

export default ActionOrders;
